import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./SideNav.css";

function SideNav() {
    const userName = localStorage.getItem("username");
    const [openMenu, setOpenMenu] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const location = useLocation();
    const [allowedModules, setAllowedModules] = useState([]);

    useEffect(() => {
        debugger
        // AdminLTE initialise automatiquement les treeview au chargement complet
        // On doit déclencher manuellement l'initialisation ici
        //const treeview = window.$('[data-widget="treeview"]');
        // if (treeview.length > 0 && typeof treeview.Treeview === 'function') {
        //     treeview.Treeview('init');
        // }
        const modules = JSON.parse(localStorage.getItem("allowedModules") || "[]");
        setAllowedModules(modules);
    }, []);

    const hasAccess = (path) => {

        const role = (localStorage.getItem("role") || "").toLowerCase();
        const adminOnlyPages = ["/users", "/roles"];
if (path.startsWith("/archives"))
            return true;
        if (path.startsWith("/archives"))
            return true;

        if (path.startsWith("/projets"))      // ← Gestion de projets
            return true;

        if (adminOnlyPages.includes(path) && role !== "admin")
            return false;

        const moduleMap = {
            "/accueil": 1,
            "/pays": 2,
            "/villes": 2,
            "/familles-articles": 2,
            "/sub-familles-articles": 2,
            "/depots": 2,
            "/marques": 2,
            "/unites": 2,
            "/types-fournisseurs": 2,
            "/types-clients": 2,
            "/payment-modes": 2,
            "/roles": 3,
            "/users": 3,
            "/changePassword": 3,
            "/fournisseurs": 4,
            "/clients": 4,
            "/achats-devis": 5,
            "/achats-bons-commande": 5,
            "/achats-bons-livraison": 5,
            "/achats-bons-retour": 5,
            "/achats-factures": 5,
            "/achats-reglements": 5,
            "/achats-transfert": 5,
            "/achats-payments": 5,
            "/achats-releves": 5,
            "/achats-releves-detail": 5,
            "/ventes-releves-detail": 5,
            "/ventes-devis": 6,
            "/ventes-bons-commande": 6,
            "/ventes-bons-livraison": 6,
            "/ventes-bons-retour": 6,
            "/ventes-factures": 6,
            "/ventes-reglements": 6,
            "/ventes-transfert": 6,
            "/ventes-payments": 6,
            "/ventes-releves": 6,
            "/articles": 7,
            "/archives": 8,
            "/archives/recherche": 8,
             "/projets": 9,
            "/projets/liste": 9,
            "/projets/employes": 9
        };
        const moduleId = moduleMap[path];
        const module = allowedModules.find(m => m.id === moduleId);

        return module?.canRead;
    };

    useEffect(() => {
        const activeMenuItem = menuItems.find(item =>
            item.submenu ? item.submenu.some(sub => sub.path === location.pathname) : location.pathname === item.path
        );
        if (activeMenuItem) {
            setOpenMenu(activeMenuItem.title);
            setActiveMenu(activeMenuItem.title);
        } else {
            setActiveMenu(null);
        }
    }, [location.pathname]);

    const toggleMenu = (menu) => {
        debugger
        setOpenMenu(prevMenu => prevMenu === menu ? null : menu);
        setActiveMenu(menu);
    };

    const menuItems = [
        {
            title: "Tableau de bord",
            icon: "fas fa-chart-line",
            path: "/",
        },
        {
            title: "Profil",
            icon: "fas fa-user-circle",
            submenu: [
                { title: "Modifier mot de passe", path: "/changePassword", icon: "fas fa-key" }
            ]
        },
        {
            title: "Paramètres",
            icon: "fas fa-cogs",
            submenu: [
                { title: "Pays", path: "/pays", icon: "fas fa-flag" },
                { title: "Villes", path: "/villes", icon: "fas fa-city" },
                { title: "Familles Articles", path: "/familles-articles", icon: "fas fa-boxes" },
                { title: "depots", path: "/depots", icon: "fas fa-city" },
                { title: "Sous Familles Articles", path: "/sub-familles-articles", icon: "fas fa-box-open" },
                { title: "Familles Fournisseurs", path: "/types-fournisseurs", icon: "fas fa-truck" },
                { title: "Familles Clients", path: "/types-clients", icon: "fas fa-user-friends" },
                { title: "Marques", path: "/marques", icon: "fas fa-tags" },
                { title: "Unités de gestion", path: "/unites", icon: "fas fa-balance-scale" },
                { title: "Modes de payement", path: "/payment-modes", icon: "fas fa-money-check-alt" },
               // { title: "Projets", path: "/archives/projets", icon: "fas fa-hard-hat" },
            ],
            
        },
        {
            title: "Gestion des Utilisateurs",
            icon: "fas fa-user-cog",
            submenu: [
                { title: "Utilisateurs", path: "/users", icon: "fas fa-user" },
                { title: "Rôles", path: "/roles", icon: "fas fa-user-tag" },
            ],
        },
        {
            title: "Clients & Fournisseurs",
            icon: "fas fa-users-cog",
            submenu: [
                { title: "Clients", path: "/clients", icon: "fas fa-user-tie" },
                { title: "Fournisseurs", path: "/fournisseurs", icon: "fas fa-user-shield" },
            ],
        },
        {
            title: "Gestion des Articles",
            icon: "fas fa-boxes", // 🧱 (ensemble d’articles, inventaire)
            submenu: [
                { title: "Articles", path: "/articles", icon: "fas fa-box" }
            ],
        },
        {
            title: "Gestion des Achats",
            icon: "fas fa-shopping-cart",
            submenu: [
                { title: "Demandes d'achat", path: "/achats-devis", icon: "fas fa-file-invoice" },
                { title: "Bon de commande", path: "/achats-bons-commande", icon: "fas fa-file-signature" },
                { title: "Bons de réception", path: "/achats-bons-livraison", icon: "fas fa-truck-loading" },
                { title: "Bon de retour", path: "/achats-bons-retour", icon: "fas fa-truck-loading" },
                { title: "Factures d'achat", path: "/achats-factures", icon: "fas fa-file-invoice-dollar" },
                { title: "Transfert", path: "/achats-transfert", icon: "fas fa-exchange-alt" },
                { title: "Réglements", path: "/achats-payments", icon: "fas fa-money-check-alt" },
                { title: "Relevés", path: "/achats-releves", icon: "fas fa-file-alt" },
                 { title: "Relevés avec Articles", path: "/achats-releves-detail", icon: "fas fa-file-alt" }
            ],
        },
        {
            title: "Gestion des Ventes",
            icon: "fas fa-cash-register",
            submenu: [
                { title: "Devis", path: "/ventes-devis", icon: "fas fa-file-invoice" },
                { title: "Bon de commande", path: "/ventes-bons-commande", icon: "fas fa-file-signature" },
                { title: "Bon de livraison", path: "/ventes-bons-livraison", icon: "fas fa-truck" },
                { title: "Bon de retour", path: "/ventes-bons-retour", icon: "fas fa-truck-loading" },
                { title: "Factures", path: "/ventes-factures", icon: "fas fa-file-invoice-dollar" },
                { title: "Transfert", path: "/ventes-transfert", icon: "fas fa-exchange-alt" },
                { title: "Réglements", path: "/ventes-payments", icon: "fas fa-money-check-alt" },
                { title: "Relevés", path: "/ventes-releves", icon: "fas fa-file-alt" },
                { title: "Relevés avec Articles", path: "/ventes-releves-detail", icon: "fas fa-file-alt" }
            ],
        },
       {
    title: "Gestion de projets",
    icon: "fas fa-project-diagram",
    submenu: [
        { title: "Tableau de bord", path: "/projets",          icon: "fas fa-tachometer-alt" },
        { title: "Projets",         path: "/projets/liste",    icon: "fas fa-list" },
        { title: "Tâches",          path: "/projets/taches",   icon: "fas fa-tasks" },
        { title: "Employés",        path: "/projets/employes", icon: "fas fa-users" },
        { title: "Rapports Projets",        path: "/projets/RapportsProjets", icon: "fas fa-users" },
    ],
},
         {
            title: "Archives",
            icon: "fas fa-archive",
            submenu: [
                { title: "Tableau de bord", path: "/archives/dashboard", icon: "fas fa-folder-open" },
               { title: "Dossiers", path: "/archives", icon: "fas fa-folder-open" },
                { title: "Documents", path: "/archives/documents", icon: "fas fa-file-alt" },
                //  { title: "Recherche", path: "/archives/recherche", icon: "fas fa-search" },
                 { title: "Corbeille", path: "/archives/corbeille", icon: "fas fa-trash-restore" }
            ],
        },
    ];

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <NavLink to="/" className="brand-link">
                <img src={`${process.env.PUBLIC_URL}/dist/img/logo_commerce_4.png`} alt="AdminLTE Logo" className="brand-image img-circle elevation-3   " style={{ opacity: ".8" }} />
                <span className="brand-text font-weight-light">Gestion Commerciale</span>
            </NavLink>

            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img src={`${process.env.PUBLIC_URL}/dist/img/user2-160x160.jpg`} className="img-circle elevation-2" alt="User" />
                    </div>
                    <div className="info">
                        <NavLink to="#" className="d-block">{userName}</NavLink>
                    </div>
                </div>

                <nav className="mt-2">
                    <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                        {menuItems.map((item, index) => {
                            if (item.submenu) {
                                const visibleSubItems = item.submenu.filter(subItem => hasAccess(subItem.path));
                                if (visibleSubItems.length === 0) return null;
                                return (
                                    <li key={index} className="nav-item">
                                        <a
                                            className={`nav-link ${activeMenu === item.title ? "active-menu" : ""}`}
                                            onClick={() => toggleMenu(item.title)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <i className={`nav-icon ${item.icon}`} />
                                            <p>
                                                {item.title}
                                                <i className="right fas fa-angle-left" />
                                            </p>
                                        </a>
                                        <ul className={`nav nav-treeview ${openMenu === item.title ? "show-menu" : ""}`}>
                                            {visibleSubItems.map((subItem, subIndex) => (
                                                <li key={subIndex} className="nav-item">
                                                    <NavLink to={subItem.path} className="nav-link">
                                                        <i className={`nav-icon ${subItem.icon}`} />
                                                        <p>{subItem.title}</p>
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                );
                            } else {
                                return (
                                    <li key={index} className="nav-item">
                                        <NavLink
                                            to={item.path}
                                            className={`nav-link ${activeMenu === item.title ? "active-menu" : ""}`}
                                            onClick={() => setActiveMenu(item.title)}
                                        >
                                            <i className={`nav-icon ${item.icon}`} />
                                            <p>{item.title}</p>
                                        </NavLink>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                </nav>
            </div>
        </aside>
    );
}

export default SideNav;
